import { NATIVE_APP_AGENT } from './native-app';

/**
 * Открыто ли в нативном React Native приложении. В браузере
 * window.ReactNativeWebView тоже есть (его создаёт скрипт контракта),
 * но без postMessage и без нативного user agent
 */
const isNativeApp = () => {
	return (
		navigator.userAgent.includes(NATIVE_APP_AGENT) ||
		typeof window.ReactNativeWebView?.postMessage === 'function'
	);
};

/**
 * Приложение отключено для бренда (флаг is_app_disabled из контракта хоста):
 * в нативном приложении вместо него показывается экран недоступности,
 * в браузере сайт работает как обычно
 */
export const isAppDisabled = () => {
	if (!window.ReactNativeWebView?.is_app_disabled) {
		return false;
	}

	return isNativeApp();
};
